import React from 'react';
import { func, string } from 'prop-types';
import { Image } from '@thd-olt-component-react/core-ui';
import styles from './form-header.module.scss';

export const FormHeader = ({ onClose, title }) => {

  return (
    <div className={styles['form-header']}>
      <h2>{title}</h2>
      {onClose && (
        <button onClick={onClose} type="button">
          <Image height={20} width={20} asset="close-symbol-orange.svg" alt="Close" />
        </button>
      )}
    </div>
  );
};

FormHeader.displayName = 'ListFormsFormHeader';

FormHeader.propTypes = {
  onClose: func,
  title: string
};

FormHeader.defaultProps = {
  onClose: null,
  title: null
};
